import React from 'react';
import { useLocation } from 'react-router-dom';
import WhatsAppLogs from '../dashboard/WhatsAppLogs';

export default function DevLogsPage() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const devKey = params.get('key') || params.get('dev_key') || '';

  return (
    <WhatsAppLogs
        endpoint="/dev/logs"
        title="App Logs"
        subtitle="Search, export, and inspect logs across the entire app."
        useDevConsole
        hideEventFilter
        hideAppBanner
        devKey={devKey}
      />
  );
}
